var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getOriginalUser } from '../../services/utilisateur';
import { useState } from 'react';
import * as ServiceAffaire from '../../services/affaire';
import * as ServiceUtils from '../../services/utils';
import { getYearAndMonthInStringDate } from '../../services/dashboard';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { CloneAffaireSchema } from '../../utils/ValidationSchema';
import { toUpperCaseFirstChar } from '../../theme';
import { Modal } from '../../utils/Modal';
import { AffaireIcon, CloseIcon } from '../../utils/Icons';
import { Typography } from '../../utils/Typography';
import { Stack } from '@mui/material';
import { IconButton } from '../../utils/IconButton';
export var ClonerAffaire = function (_a) {
    var AffaireId = _a.AffaireId, DefaultClientId = _a.DefaultClientId, DefaultMoisSignature = _a.DefaultMoisSignature, handleClose = _a.handleClose;
    var _b = getYearAndMonthInStringDate(DefaultMoisSignature), DefaultOnlyYearMoisSignature = _b.Annee, DefaultOnlyMonthMoisSignature = _b.Mois;
    var originalUser = getOriginalUser();
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState([]), collaborateurs = _d[0], setCollaborateurs = _d[1];
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Cl\u00F4nage d'affaire", color: "affaire", iconTitle: _jsx(AffaireIcon, {}) }, { children: _jsx(FormikGenerator, { validationSchema: CloneAffaireSchema, submitLabel: 'Clôner', datas: {
                    OtherClient: false,
                    OnlyMonthMoisSignature: DefaultOnlyMonthMoisSignature,
                    OnlyYearMoisSignature: DefaultOnlyYearMoisSignature,
                }, onSubmit: function (_a) {
                    var OtherClient = _a.OtherClient, ClientId = _a.ClientId, CollaborateurProprietaireId = _a.CollaborateurProprietaireId, DuplicateEquipe = _a.DuplicateEquipe, Libelle = _a.Libelle, OnlyMonthMoisSignature = _a.OnlyMonthMoisSignature, OnlyYearMoisSignature = _a.OnlyYearMoisSignature;
                    return __awaiter(void 0, void 0, void 0, function () {
                        var MoisSignature;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    MoisSignature = OnlyYearMoisSignature * 100 + OnlyMonthMoisSignature;
                                    return [4 /*yield*/, ServiceAffaire.clonerAffaire({
                                            AffaireId: AffaireId,
                                            OtherClient: OtherClient,
                                            ClientId: OtherClient ? ClientId : DefaultClientId,
                                            DuplicateEquipe: OtherClient ? DuplicateEquipe : null,
                                            CollaborateurProprietaireId: OtherClient
                                                ? CollaborateurProprietaireId
                                                : null,
                                            Libelle: Libelle,
                                            MoisSignature: MoisSignature,
                                        })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                }, additionalInitialValues: ['IdAffaire', 'ClientId'], renderHeader: function (_a) {
                    var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                    var clientName = values.ClientId__options && values.ClientId__options.label
                        ? values.ClientId__options.label
                        : null;
                    return (_jsxs(Stack, __assign({ spacing: 1, className: "mb-small" }, { children: [renderField({
                                label: 'Créer chez un autre client',
                                name: 'OtherClient',
                                type: TYPES.BOOLEAN,
                            }), values.OtherClient ? (_jsx(_Fragment, { children: clientName ? (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(Typography, __assign({ variant: "body1", className: "bold" }, { children: "Client :" })), _jsx(Typography, __assign({ variant: "body1" }, { children: clientName })), _jsx(IconButton, __assign({ tooltip: "Changer de client", color: "error", onClick: function () {
                                                setFieldValue("ClientId", null);
                                                setFieldValue('ClientId__options', null);
                                            } }, { children: _jsx(CloseIcon, {}) }))] }))) : (renderField({
                                    label: 'Client',
                                    name: 'ClientId',
                                    type: TYPES.SELECT,
                                    afterChange: function (value, values) { return __awaiter(void 0, void 0, void 0, function () {
                                        var datas;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, ServiceUtils.getSelectOptions('collaborateurs', { ClientId: value })];
                                                case 1:
                                                    datas = _a.sent();
                                                    setCollaborateurs(datas);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    asyncOptions: 'clients',
                                })) })) : (_jsx(_Fragment, {}))] })));
                }, fields: [
                    [
                        {
                            label: 'Propriétaire',
                            name: 'CollaborateurProprietaireId',
                            type: TYPES.SELECT,
                            options: collaborateurs,
                            show: function (values) {
                                return !!values.OtherClient &&
                                    values.ClientId &&
                                    originalUser.Licence.UseVision &&
                                    !values.IdAffaire;
                            },
                        },
                        {
                            name: 'DuplicateEquipe',
                            label: "Dupliquer l'équipe du client",
                            type: TYPES.BOOLEAN,
                            show: function (values) {
                                return !!values.OtherClient &&
                                    values.ClientId &&
                                    originalUser.Licence.UseVision &&
                                    !values.IdAffaire;
                            },
                        },
                        {
                            name: 'Libelle',
                            label: 'Libelle',
                            type: TYPES.TEXT,
                            uppercaseFirstChar: true,
                            autoFocus: true,
                        },
                        {
                            xs: 8,
                            name: 'OnlyMonthMoisSignature',
                            label: 'Mois signature',
                            type: TYPES.SELECT,
                            isRequired: true,
                            options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (month) {
                                return {
                                    value: month + 1,
                                    label: toUpperCaseFirstChar(new Date(0, month, 1).toLocaleString('fr-FR', {
                                        month: 'long',
                                    })),
                                };
                            }),
                        },
                        {
                            xs: 4,
                            name: 'OnlyYearMoisSignature',
                            label: 'Année signature',
                            type: TYPES.TEXT,
                            isRequired: true,
                            onlyDigits: true,
                        },
                    ],
                ] }) })) }));
};
//# sourceMappingURL=ClonerAffaire.js.map